module.exports = __webpack_public_path__ + "img/pennyExample.d58a1b7a.svg";